import services from 'services/module';
import { AnimatronProjectsFactory } from './AnimatronProjectsSvc';

export class UserProjectCountSvc {
    constructor(private AnimatronProjects: AnimatronProjectsFactory) {}

    getCount() {
        const params: ProjectSearchCriteria = {
            product: 'WAVE',
            offset: 0,
            limit: 0
        };

        const animatronProjects = new this.AnimatronProjects(params, true);
        return animatronProjects.nextPage().then(() => animatronProjects.count);
    }
}

services.service('userProjectCountSvc', UserProjectCountSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/userProjectCount.ts